export default "__VITE_ASSET__BxmPFyNB__"